import { __assign, __spreadArray } from "tslib";
import * as React from 'react';
import Event from '../Event/Event';
import ShowMore from '../ShowMore/ShowMore';
import AddIcon from '@material-ui/icons/Add';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import EventTypes from '../../../enums/EventTypesEnum';
import { isEvent1After2, insertionSort, } from '../../containers/Calendar/CalendarUtlis/CalendarUtils';
import { weekFirstPriorities } from '../../containers/Calendar/CalendarUtlis/EventsPriority';
import { st, classes } from './Events.st.css';
import { setOpacity } from '../../../utils/colorUtils';
var Events = function (_a) {
    var _b = _a.eventPopperModifiers, eventPopperModifiers = _b === void 0 ? null : _b, _c = _a.hoverEventId, hoverEventId = _c === void 0 ? '' : _c, _d = _a.toggleEventRender, toggleEventRender = _d === void 0 ? false : _d, _e = _a.isPastShown, isPastShown = _e === void 0 ? false : _e, _f = _a.isSorted, isSorted = _f === void 0 ? false : _f, _g = _a.isInPopper, isInPopper = _g === void 0 ? false : _g, _h = _a.isAgenda, isAgenda = _h === void 0 ? false : _h, events = _a.events, _j = _a.isTimeShown, isTimeShown = _j === void 0 ? true : _j, popperPlacement = _a.popperPlacement, popperStyle = _a.popperStyle, _k = _a.handleShowMoreClick, handleShowMoreClick = _k === void 0 ? null : _k, timeFormat = _a.timeFormat, isMobile = _a.isMobile, _l = _a.cellHeight, cellHeight = _l === void 0 ? 0 : _l, _m = _a.calendarWidth, calendarWidth = _m === void 0 ? 0 : _m, _o = _a.isShrinking, isShrinking = _o === void 0 ? false : _o, _p = _a.className, className = _p === void 0 ? '' : _p, _q = _a.dateHeight, dateHeight = _q === void 0 ? 0 : _q, eventTitleHeight = _a.eventTitleHeight, eventTimeHeight = _a.eventTimeHeight, _r = _a.handleEventTitleResize, handleEventTitleResize = _r === void 0 ? function (width, height) { } : _r, _s = _a.handleEventTimeResize, handleEventTimeResize = _s === void 0 ? function (width, height) { } : _s, _t = _a.handleEventCut, handleEventCut = _t === void 0 ? null : _t, _u = _a.eventHoverHandler, eventHoverHandler = _u === void 0 ? null : _u, _v = _a.cuttedEventIndex, cuttedEventIndex = _v === void 0 ? Infinity : _v, _w = _a.cuttedDate, cuttedDate = _w === void 0 ? '' : _w, _x = _a.cellDate, cellDate = _x === void 0 ? '' : _x, _y = _a.openPopup, openPopup = _y === void 0 ? null : _y, _z = _a.onEventExpanded, onEventExpanded = _z === void 0 ? null : _z, _0 = _a.onCopyClick, onCopyClick = _0 === void 0 ? null : _0, _1 = _a.onLocationClick, onLocationClick = _1 === void 0 ? null : _1, _2 = _a.onAttachmentClick, onAttachmentClick = _2 === void 0 ? null : _2, _3 = _a.setFirstEventRef, setFirstEventRef = _3 === void 0 ? null : _3, _4 = _a.handleShowMoreEnter, handleShowMoreEnter = _4 === void 0 ? null : _4, weekStarter = _a.weekStarter, timezone = _a.timezone, experiments = _a.experiments, localeToggle = _a.localeToggle, isStretchable = _a.isStretchable, privetEventsTitle = _a.privetEventsTitle;
    var maxEventsAmount = isStretchable && !isAgenda ? 10 : 3;
    var _5 = React.useState(events.length > maxEventsAmount ? maxEventsAmount : events.length), eventsAmount = _5[0], setEventsAmount = _5[1];
    var _6 = React.useState(false), isMounted = _6[0], setIsMounted = _6[1];
    var eventsContainerRef = React.useRef(null);
    var eventsRef = React.useRef(null);
    var padding = 20; // cell top+bottom paddings
    var paddingBottom = 4; // the padding-bottom that doesn't apply on the show-more button
    var eventPadding = 10;
    var eventHeight = eventTitleHeight > eventTimeHeight ? eventTitleHeight : eventTimeHeight;
    eventHeight =
        isStretchable && !isAgenda ? eventHeight + eventPadding : eventHeight;
    var showMoreHeight = eventTitleHeight;
    var getNextHeight = function (nextAmount) {
        if (nextAmount === maxEventsAmount && events.length === maxEventsAmount) {
            return nextAmount * eventHeight;
        }
        return nextAmount * eventHeight + showMoreHeight - paddingBottom;
    };
    // This should be refactor: move events resize logic to MonthlyCalendar.tsx, and pass events amount in the props
    React.useEffect(function () {
        var containerRefHeight = Math.abs(eventsContainerRef.current.getBoundingClientRect().height);
        var oneEvent = eventHeight + showMoreHeight - paddingBottom;
        var eventsSize = eventsAmount <= 1 ? oneEvent : containerRefHeight; // when one events and show more
        if (eventsAmount > 1 && events.length > 1) {
            eventsSize = eventsAmount * eventHeight + showMoreHeight - paddingBottom;
        }
        var newEventsAmount = eventsAmount;
        var cellEventsSize = cellHeight - dateHeight - padding; // cell height is the height of the <td>
        var nextHeight = getNextHeight(newEventsAmount + 1);
        while (eventHeight &&
            dateHeight &&
            cellHeight &&
            newEventsAmount > 0 &&
            isShrinking &&
            cellEventsSize <= eventsSize) {
            --newEventsAmount;
            if (newEventsAmount <= 1) {
                eventsSize = oneEvent;
                continue;
            }
            eventsSize =
                newEventsAmount === maxEventsAmount - 1
                    ? eventsSize
                    : eventsSize - eventHeight;
        }
        while (eventHeight &&
            dateHeight &&
            cellHeight &&
            newEventsAmount < maxEventsAmount &&
            newEventsAmount < events.length &&
            cellEventsSize >= nextHeight &&
            !isShrinking) {
            newEventsAmount++;
            nextHeight = getNextHeight(newEventsAmount + 1);
        }
        if (!isMobile) {
            setEventsAmount(newEventsAmount);
        }
        !isMounted && eventHeight && setIsMounted(true);
    }, [cellHeight, isShrinking, dateHeight, eventTimeHeight, eventTitleHeight]);
    var eventsToIterate = __spreadArray([], events, true);
    if (isSorted) {
        // for example: popup && agenda cell need the events sorted
        eventsToIterate = insertionSort(events, function (event1, event2) {
            return isEvent1After2(event1, event2, weekFirstPriorities);
        });
    }
    var emptyEvents = events.reduce(function (sum, currentEvent) {
        return currentEvent.type === EventTypes.Null ? sum + 1 : sum;
    }, 0);
    var eventsToShow = null;
    var showMore = null;
    var eventsLength = events.length;
    var jsxEvents = [];
    var isShowingMore = handleShowMoreClick
        ? eventsLength > eventsAmount
        : false;
    var eventsToShowAmount = isShowingMore ? eventsAmount : eventsLength;
    if (isShowingMore &&
        eventsToShowAmount === maxEventsAmount &&
        maxEventsAmount < eventsLength) {
        eventsToShowAmount = eventsToShowAmount - 1;
    }
    if (eventsLength - eventsToShowAmount === 1 && eventsLength > 1) {
        eventsToShowAmount = eventsToShowAmount + 1;
    }
    var moreEventsCount = isShowingMore
        ? eventsLength - eventsToShowAmount - emptyEvents
        : 0;
    if (eventsToShowAmount === eventsLength && eventsLength > 1) {
        isShowingMore = false;
    }
    if (isShowingMore && moreEventsCount <= 0) {
        moreEventsCount = eventsLength - emptyEvents;
    }
    showMore = isShowingMore ? (React.createElement(ShowMore, { calendarWidth: calendarWidth, key: "ShowMore", handleClick: handleShowMoreClick, moreEventsCount: moreEventsCount, isMobile: isMobile, handleShowMoreEnter: handleShowMoreEnter, experiments: experiments, localeToggle: localeToggle, privetEventsTitle: privetEventsTitle })) : null;
    if (isMobile && !isAgenda) {
        showMore = isShowingMore ? (React.createElement(AddIcon, { classes: { root: classes.Plus } })) : null;
    }
    for (var i = 0; i < eventsToShowAmount; i++) {
        var eventColor = eventsToIterate[i].eventColor || '';
        if (isMobile && !isAgenda) {
            eventsToIterate[i].type !== EventTypes.Null &&
                jsxEvents.push(React.createElement(FiberManualRecordIcon, { key: eventsToIterate[i].id, classes: { root: classes.Bullet }, htmlColor: eventColor ? setOpacity(1, eventColor) : eventColor }));
        }
        else {
            jsxEvents.push(React.createElement("li", { key: eventsToIterate[i].id },
                React.createElement(Event, __assign({ isMobile: isMobile }, eventsToIterate[i], { localeToggle: localeToggle, isTimeShown: isTimeShown, popperPlacement: popperPlacement, popperStyle: popperStyle, isInPopper: isInPopper, timeFormat: timeFormat, handleTitleResize: i === 0 ? handleEventTitleResize : null, handleTimeResize: i === 0 ? handleEventTimeResize : null, className: classes.EventExtension, isAgenda: isAgenda, handleCut: handleEventCut, isCut: i >= cuttedEventIndex, eventIndex: i, cuttedEventIndex: cuttedEventIndex, cuttedDate: cuttedDate, isPastShown: isPastShown, cellDate: cellDate, toggleEventRender: toggleEventRender, isHover: (hoverEventId &&
                        eventsToIterate[i].originEventId === hoverEventId) ||
                        eventsToIterate[i].id === hoverEventId, onHover: eventHoverHandler, popperModifiers: eventPopperModifiers, openPopup: openPopup, onEventExpanded: onEventExpanded, onCopyClick: onCopyClick, onLocationClick: onLocationClick, onAttachmentClick: onAttachmentClick, setFirstEventRef: setFirstEventRef, weekStarter: weekStarter, timezone: timezone, experiments: experiments, privetEventsTitle: privetEventsTitle }))));
        }
    }
    eventsToShow = (React.createElement("section", { "aria-labelledby": cellDate },
        React.createElement("ul", { ref: eventsRef, className: st(classes.root, { isInPopper: isInPopper, isMobile: isMobile }, className) }, jsxEvents)));
    return (React.createElement("div", { ref: eventsContainerRef, className: st(classes.EventsContainer, {
            isMobile: isMobile,
            isMounted: isMounted,
            isAgenda: isAgenda,
            isInPopper: isInPopper,
        }) },
        eventsToShow,
        showMore));
};
export default Events;
//# sourceMappingURL=Events.js.map